import styled from 'styled-components';

import { palette } from './palette';

// Re-themes the shared marketplace footer (FooterAddition + GlobalFooterContent)
// to the dark-green homepage palette without forking its content.
export const DarkFooterTheme = styled.footer`
  background: ${palette.bgDeep};

  && > div {
    background-color: ${palette.bgDeep};
  }

  && div {
    border-bottom-color: rgba(243, 234, 216, 0.15);
  }

  && a {
    color: ${palette.cream};
  }

  && h3,
  && p {
    color: ${palette.creamDim};
  }
`;
